import { Route } from "@angular/router";
import { PlanoDetalhePage } from "./plano-detalhe.page";

export const PlanoDetalheRouter: Route[] = [
  { path: 'plano-detalhe', component: PlanoDetalhePage }
];
